module.exports = __webpack_public_path__ + "d03f4bf056b04644a19323b7980fee46.png";